// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimActorAggregatorDto
 */
export interface IClaimActorAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimActorAggregatorDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActorAggregatorDto
     */
    claim_actor_type: IClaimActorAggregatorDtoClaimActorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimActorAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActorAggregatorDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActorAggregatorDto
     */
    contact_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActorAggregatorDto
     */
    card_processor_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActorAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActorAggregatorDto
     */
    full_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimActorAggregatorDto
     */
    is_hidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimActorAggregatorDto
     */
    is_view_name_allowed?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IClaimActorAggregatorDtoClaimActorTypeEnum {
    SYSTEM = 'SYSTEM',
    EMPLOYEE = 'EMPLOYEE',
    DEPENDENT = 'DEPENDENT',
    ADMIN = 'ADMIN',
    CARD_PROCESSOR = 'CARD_PROCESSOR',
    PARTNER_USER = 'PARTNER_USER'
}


/**
 * Check if a given object implements the IClaimActorAggregatorDto interface.
 */
export function instanceOfIClaimActorAggregatorDto(value: object): value is IClaimActorAggregatorDto {
    if (!('claim_actor_type' in value) || value['claim_actor_type'] === undefined) return false;
    return true;
}

export function IClaimActorAggregatorDtoFromJSON(json: any): IClaimActorAggregatorDto {
    return IClaimActorAggregatorDtoFromJSONTyped(json, false);
}

export function IClaimActorAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActorAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_actor_type': json['claim_actor_type'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'card_processor_id': json['card_processor_id'] == null ? undefined : json['card_processor_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'full_name': json['full_name'] == null ? undefined : json['full_name'],
        'is_hidden': json['is_hidden'] == null ? undefined : json['is_hidden'],
        'is_view_name_allowed': json['is_view_name_allowed'] == null ? undefined : json['is_view_name_allowed'],
    };
}

export function IClaimActorAggregatorDtoToJSON(json: any): IClaimActorAggregatorDto {
    return IClaimActorAggregatorDtoToJSONTyped(json, false);
}

export function IClaimActorAggregatorDtoToJSONTyped(value?: IClaimActorAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_actor_type': value['claim_actor_type'],
        'employee_id': value['employee_id'],
        'dependent_id': value['dependent_id'],
        'contact_id': value['contact_id'],
        'card_processor_id': value['card_processor_id'],
        'organization_id': value['organization_id'],
        'full_name': value['full_name'],
        'is_hidden': value['is_hidden'],
        'is_view_name_allowed': value['is_view_name_allowed'],
    };
}

